"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface BorrTailoringQuestionsProps {
  onBack?: () => void;
}

const tailoringQuestions: TailoringQuestion[] = [
  { 
    id: "bor-1", 
    question: "Are there any new/amended borrowings taken in current period by the entity?", 
    type: "radio",
    options: ["Yes", "No"] 
  },
  { 
    id: "bor-2", 
    question: "Are there any repayments made by entity for the sum(s) borrowed?", 
    type: "radio",
    options: ["Yes", "No"] 
  },
  { 
    id: "bor-3", 
    question: "Have any debentures been issued by the entity in the current period?", 
    type: "radio",
    options: ["Yes", "No"] 
  },
  { 
    id: "bor-4", 
    question: "Are there any related party transactions in borrowings in the current period?", 
    type: "radio",
    options: ["Yes", "No"] 
  },
];

export default function BorrTailoringQuestions({ onBack }: BorrTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Borrowings"
      title="Borrowings - Tailoring Questions"
      description="Answer the following Yes/No questions."
      questions={tailoringQuestions}
      onBack={onBack}
    />
  );
}


